import { Observable } from 'rxjs';
import { User } from './../user.model';
import { AuthService } from './../auth.service';
import { CartService } from './../cart.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-itinerary-customer-requests',
  templateUrl: './itinerary-customer-requests.component.html',
  styleUrls: ['./itinerary-customer-requests.component.css']
})
export class ItineraryCustomerRequestsComponent implements OnInit {

  user$: Observable<User>;

  constructor(private cartService: CartService, private authService: AuthService) { }

  ngOnInit() {
    this.user$ = this.authService.user$;
  }

}
